
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import Dashboard from "./pages/Dashboard";
import ProjectMaster from "./pages/ProjectMaster";
import ClientMaster from "./pages/ClientMaster";
import WorkerMaster from "./pages/WorkerMaster";
import TransactionMaster from "./pages/TransactionMaster";
import LoginPage from "./pages/LoginPage";
import SupplierMaster from "./pages/SupplierMaster";
import "./App.css";

function App() {
  const [isOpen, setIsOpen] = useState(true);
  const [user, setUser] = useState(null);
  const [loggingOut, setLoggingOut] = useState(false);
  const toggleSidebar = () => {
    setIsOpen(prev => !prev);
  };
  const handleLogin = (userData) => {
    setUser(userData);
  };
  const handleLogout = () => {
    setLoggingOut(true);
    setTimeout(() => {
      setUser(null);
      setLoggingOut(false);
    }, 400);
  };
  if (!user) {
    return <LoginPage onLogin={handleLogin} />;
  }
  return (
    <Router>
      <div className="layout">

        <Sidebar isOpen={isOpen} />

        <div className={`main ${!isOpen ? "collapsed" : ""}`}>
          <Topbar
            toggleSidebar={toggleSidebar}
            user={user}
            onLogout={handleLogout}
          />

          <div className="content p-4">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/projects" element={<ProjectMaster />} />
              <Route path="/clients" element={<ClientMaster />} />
              <Route path="/WorkerMaster" element={<WorkerMaster />} />
              <Route path="/suppliers" element={<SupplierMaster />} />
              <Route path="/transactions" element={<TransactionMaster />} />
              <Route path="*" element={<Navigate to="/transactions" replace />} />
            </Routes>
          </div>
        </div>

      </div>
    </Router>
  );
}

export default App;
